import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'
import { locationStore } from './location'
import moment from 'moment'

export const dashboardStore = defineStore({
  id: 'dashboard',
  state: () => ({
    selectedCorp: null,
    selectedInsurer: null,
    selectedInsurerClass: null,
    startDate: moment().subtract(1, 'day').format('YYYY-MM-DD'), // localStorage.getItem('startDate') ? localStorage.getItem('startDate') : moment().subtract(1, 'day').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'), // localStorage.getItem('endDate') ? localStorage.getItem('endDate') : moment().format('YYYY-MM-DD'),
    filters: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters')) : null,
    dashboardFilters: [],
    tableDefaultButtons: [
      {
        text: 'Show List',
        className: 'Toggle-buttons btn-show-list btn-custome-circle me-2 btn active',
        action: function (e) {
          // onClickFunction(e, 'Show List')
          console.log(e)
        }
      },
      {
        text: 'Show Cards',
        className: 'Toggle-buttons btn-show-cards btn-custome-circle btn', // active
        action: function (e) {
          // onClickFunction(e, 'Show List')
          console.log(e)
        }
      }
    ],
    averageAmount: 0,
    searchQuery: null,
    cardDataOriginal: null,
    cardData: null,
    shopCardDataOriginal: null,
    shopCardData: null,
    tableDetails: null,
    chartData: null,
    breakdownData: null,
    inspectionData: {
      count: 0,
      items: []
    },
    breakdownTotals: [],
    firm: {
      firm: sessionStorage.getItem('firm') ? sessionStorage.getItem('firm') : null,
      name: sessionStorage.getItem('firmName') ? sessionStorage.getItem('firmName') : null,
      source: sessionStorage.getItem('firmSource') ? sessionStorage.getItem('firmSource') : null
    },
    cardFilters: null,
    totalInspections: 0,
    totals: [],
    vinSearchResults: null,
    // held here (not in DashboardHost) so the VIN survives opening an inspection and coming back
    vinSearchTerm: null,
    isRefresh: false,
    isFetching: false,
    gridParams: {
      numItems: 0,
      page: 1,
      pageSize: 10,
      filterBy: null,
      searchTerm: '',
      orderBy: 'adasInspection',
      sortBy: 'asc'
    },
    selectedFirm: sessionStorage.getItem('firm') ? sessionStorage.getItem('firm') : null,
    dashboardTab: 'VIN Search',
    routeBack: sessionStorage.getItem('routeBack') ? sessionStorage.getItem('routeBack') : null,
    providerDashboard: []
  }),
  actions: {
    setTab(tab) {
      this.dashboardTab = tab
    },
    setInsurer(id) {
      const storeAuth = authStore()
      const storeLocation = locationStore()
      this.selectedInsurerClass = 1
      this.selectedInsurer = null
      // selection defaults to what is selected
      this.selectedCorp = parseInt(id)
      this.selectedInsurer = parseInt(id)
      // if not VIN Search, set based upon the user's role 
      if (this.dashboardTab !== 'VIN Search') {
        // if not super admin or corp admin
        if (![1, 2, 3, 4].includes(storeAuth.profile.roles[0])) {
          // set based upon the user's firm
          this.selectedInsurer = parseInt(storeAuth.profile.firm)
        }
      }
      // set the selected insurer class based on the selected insurer
      if (storeLocation.insurers) {
        let insurer = storeLocation.insurers.find((i) => parseInt(i.firm) === parseInt(this.selectedCorp))
        if (insurer) {
          this.selectedInsurerClass = insurer.firmClass
        }
      }
      console.log('Set Insurer', {
        selectedCorp: this.selectedCorp,
        selectedInsurer: this.selectedInsurer, 
        selectedInsurerClass: this.selectedInsurerClass
      })
    },
    setGridParam(data) {
      this.gridParams[data.name] = data.value
    },
    setRoute(route) {
      this.routeBack = route
      sessionStorage.setItem('routeBack', route)
    },
    setRefresh(value) {
      this.isRefresh = value
    },
    sortFunction(sortData) {
      return sortData.sort((a, b) => b.number - a.number)
    },
    sortArrayByDate(array) {
      return array.sort((a, b) => new Date(a.date).valueOf() - new Date(b.date).valueOf())
    },
    setFirm(firm) {
      this.firm = firm
      this.selectedFirm = firm.firm
      sessionStorage.setItem('firm', firm.firm)
      sessionStorage.setItem('firmName', firm.name)
      sessionStorage.setItem('firmSource', firm.source)
      this.breakdownData = null
      this.breakdownTotals = []
      this.inspectionData = null
    },
    resetData(data) {
      if (data === 'inspections') {
        this.inspectionData = null
      } else if (data === 'totals') {
        this.breakdownTotals = []
        this.inspectionData = null
      } else {
        this.breakdownData = null
        this.breakdownTotals = []
        this.inspectionData = null
      }
    },
    resetVinSearch() {
      this.vinSearchResults = null
    },
    setVinSearchTerm(vin) {
      this.vinSearchTerm = vin
    },
    resetDates() {
      this.startDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      this.endDate = moment().format('YYYY-MM-DD')
      localStorage.setItem('startDate', this.startDate)
      localStorage.setItem('endDate', this.endDate)
      // save the date range to local storage
      localStorage.setItem('daterange', JSON.stringify([this.startDate, this.endDate]))
      this.isRefresh = true
    },
    setDate(name, value) {
      if (name === 'startDate') {
        this.startDate = value
      } else if (name === 'endDate') {
        this.endDate = value
      }
      // let startDate = this.startDate ? moment(this.startDate) : moment()
      // let endDate = this.endDate ? moment(this.endDate) : moment()
      // // limit the date range to 6 months
      // // if (moment(value).isBefore(moment().subtract(6, 'months'))) {
      // //   value = moment().subtract(6, 'months').format('YYYY-MM-DD')
      // // }
      // // convert start and end dates to moment objects
      // if (name === 'startDate') {
      //   this.startDate = moment(value).format('YYYY-MM-DD')
      //   startDate = moment(value)
      // } else if (name === 'endDate') {
      //   this.endDate = moment(value).format('YYYY-MM-DD')
      //   endDate = moment(value)
      // }
      // // compare start and end dates and adjust if necessary
      // if (startDate.isAfter(endDate)) {
      //   endDate = startDate
      //   this.endDate = endDate.format('YYYY-MM-DD')
      // } else if (endDate.isBefore(startDate)) {
      //   startDate = endDate
      //   this.startDate = startDate.format('YYYY-MM-DD')
      // }
      // save them to local storage
      localStorage.setItem('startDate', this.startDate)
      localStorage.setItem('endDate', this.endDate)
      // save the date range to local storage
      localStorage.setItem('daterange', JSON.stringify([this.startDate, this.endDate]))
      this.isRefresh = true
    },
    setFilters(value) {
      if (value) {
        this.filters = value
        sessionStorage.setItem('filters', JSON.stringify(value))
      } else {
        this.filters = null
        sessionStorage.removeItem('filters')
      }
    },
    setCardFilters(value) {
      console.log('Setting Filters', value)
      if (value === 'reset') {
        this.cardFilters = null
      } else {
        this.cardFilters = value
      }
    },
    applyFilters(filters) {
      this.cardData = JSON.parse(JSON.stringify(this.cardDataOriginal))
      if (filters) {
        this.filters = filters
        sessionStorage.setItem('filters', JSON.stringify(filters))
        const keyValues = Object.entries(filters)
        keyValues.forEach((element) => {
          let cardName = element[0]
          let query = element[1].trim().toLowerCase()
          if (query !== 'all') {
            switch (cardName) {
              case 'Service':
                this.cardData.TopServices = this.cardData.TopServices.filter((x) => x.name.trim().toLowerCase() === query)
                break
              case 'Shop':
                this.cardData.TopShops = this.cardData.TopShops.filter((x) => x.name.trim().toLowerCase() === query)
                break
              case 'Make':
                this.cardData.TopMakes = this.cardData.TopMakes.filter((x) => x.name.trim().toLowerCase() === query)
                break
              case 'Estimator':
                this.cardData.TopEstimators = this.cardData.TopEstimators.filter((x) => x.name.trim().toLowerCase() === query)
                break
              case 'INS':
                this.cardData.TopInsurance = this.cardData.TopInsurance.filter((x) => x.name.trim().toLowerCase() === query)
                break
            }
          }
        })
      } else {
        this.filters = null
        sessionStorage.removeItem('filters')
      }
    },
    searchExisting(search, inWhat) {
      if (inWhat === 'shopCardData') {
        if (search) {
          let filtered = this.shopCardDataOriginal.filter((x) => {
            return Object.keys(x).reduce((a, c) => {
              let value = x[c]
              if (value !== null && value !== undefined) {
                return a || value.toString().toLowerCase().includes(search.search.toString().trim().toLowerCase())
              }
              return a
            }, false)
          })
          if (filtered) {
            this.shopCardData = JSON.parse(JSON.stringify(filtered))
            this.tableDetails.tableData = JSON.parse(JSON.stringify(filtered))
            if (this.shopCardData.length === 0) {
              this.shopCardData = 'noData'
            }
          }
        } else {
          this.shopCardData = JSON.parse(JSON.stringify(this.shopCardDataOriginal))
          this.tableDetails.tableData = JSON.parse(JSON.stringify(this.shopCardDataOriginal))
        }
      } else {
        this.shopCardData = JSON.parse(JSON.stringify(this.shopCardDataOriginal))
        this.tableDetails.tableData = JSON.parse(JSON.stringify(this.shopCardDataOriginal))
      }
    },
    async getFirmSettings() {
      const store = authStore()
      this.averageAmount = 0
      let response = await api.get(`firm/preferences?firm=${store.profile.firm}&category=General`)
      if (response) {
        if (response !== '') {
          response.map((item, index) => {
            if (item.name !== 'Logo') {
              this.averageAmount = parseFloat(response[0]['value'])
            }
          })
        }
      }
    },
    async getInsurerDashboard(id) {
      const store = authStore()
      this.cardData = null
      this.routeBack = null
      this.shopCardDataOriginal = null
      this.shopCardData = null
      this.tableDetails = null
      this.totalInspections = 0
      this.totals = []
      if (id === undefined || id === null) {
        id = store.profile.firm
      }
      if (this.isFetching === false) {
        this.isFetching = true
        const responses = await api.parallel([
          {
            method: 'get',
            url: `dashboard/topClientStats?firm=${id}&startDate=${this.startDate}&endDate=${this.endDate}&number=10&direction=top&source=ADAS&lookup=${this.selectedInsurerClass}`
          },
          {
            method: 'get',
            url: `dashboard/clientTotals?firm=${id}&startDate=${this.startDate}&endDate=${this.endDate}&source=ADAS&type=Total&lookup=${this.selectedInsurerClass}`
          }
        ])
        responses.forEach((res, i) => {
          if (res.success) {
            switch (i) {
              case 0:
                this.processCardData(res.data)
                break
              case 1:
                this.processTotals(res.data)
                break
            }
          } else if (res.error) {
            console.warn(`Request ${i + 1} failed:`, res.error)
          }
        })
        this.isFetching = false
      }
    },
    async processCardData(response) {
      if (response) {
        if (response !== '') {
          const store = authStore()
          let filters = {
            TopServices: {
              selectLabel: 'Service',
              selectOptions: [{ value: 'All', text: 'All' }]
            },
            TopShops: {
              selectLabel: 'Shop',
              selectOptions: [{ value: 'All', text: 'All' }]
            },
            TopMakes: {
              selectLabel: 'Make',
              selectOptions: [{ value: 'All', text: 'All' }]
            },
            TopEstimators: {
              selectLabel: 'Estimator',
              selectOptions: [{ value: 'All', text: 'All' }]
            },
            TopInsurance: {
              selectLabel: 'INS',
              selectOptions: [{ value: 'All', text: 'All' }]
            },
            TopEmployees: {
              selectLabel: 'Employee',
              selectOptions: [{ value: 'All', text: 'All' }]
            }
          }
          this.cardDataOriginal = {
            TopShops: [],
            TopMakes: [],
            TopEstimators: [],
            TopInsurance: [],
            TopServices: [],
            TopEmployees: []
          }
          await response.map((result) => {
            if (result.metric === 'TopShops') {
              filters.TopShops.selectOptions.push({ value: result.name, text: result.name })
            } else if (result.metric === 'TopMakes') {
              filters.TopMakes.selectOptions.push({ value: result.name, text: result.name })
            } else if (result.metric === 'TopEstimators') {
              filters.TopEstimators.selectOptions.push({ value: result.name, text: result.name })
            } else if (result.metric === 'TopInsurance') {
              filters.TopInsurance.selectOptions.push({ value: result.name, text: result.name })
            } else if (result.metric === 'TopServices') {
              filters.TopServices.selectOptions.push({ value: result.name, text: result.name })
            } else if (result.metric === 'TopEmployees') {
              filters.TopEmployees.selectOptions.push({ value: result.name, text: result.name })
            }
          })
          await response.map((result) => {
            if (result.metric === 'TopShops') {
              this.cardDataOriginal.TopShops.push(result)
            } else if (result.metric === 'TopMakes') {
              this.cardDataOriginal.TopMakes.push(result)
            } else if (result.metric === 'TopEstimators') {
              this.cardDataOriginal.TopEstimators.push(result)
            } else if (result.metric === 'TopInsurance') {
              this.cardDataOriginal.TopInsurance.push(result)
            } else if (result.metric === 'TopServices') {
              this.cardDataOriginal.TopServices.push(result)
            } else if (result.metric === 'TopEmployees') {
              this.cardDataOriginal.TopEmployees.push(result)
            }
          })

          this.cardDataOriginal.TopShops = this.cardDataOriginal?.TopShops.length ? this.sortFunction(this.cardDataOriginal.TopShops) : ''
          this.cardDataOriginal.TopMakes = this.cardDataOriginal?.TopMakes.length ? this.sortFunction(this.cardDataOriginal.TopMakes) : ''
          this.cardDataOriginal.TopEstimators = this.cardDataOriginal?.TopEstimators.length
            ? this.sortFunction(this.cardDataOriginal.TopEstimators)
            : ''
          this.cardDataOriginal.TopInsurance = this.cardDataOriginal?.TopInsurance.length ? this.sortFunction(this.cardDataOriginal.TopInsurance) : ''
          this.cardDataOriginal.TopServices = this.cardDataOriginal?.TopServices.length ? this.sortFunction(this.cardDataOriginal.TopServices) : ''
          this.cardDataOriginal.TopEmployees = this.cardDataOriginal?.TopEmployees.length ? this.sortFunction(this.cardDataOriginal.TopEmployees) : ''
          this.cardData = JSON.parse(JSON.stringify(this.cardDataOriginal))
          if (store.dashboardName === 'repairnetwork') {
            this.dashboardFilters = [filters?.TopServices ?? {}, filters?.TopShops ?? {}, filters?.TopMakes ?? {}, filters?.TopEstimators ?? {}]
          } else if (store.dashboardName === 'calibration') {
            this.dashboardFilters = [filters?.TopInsurance ?? {}, filters?.TopShops ?? {}, filters?.TopMakes ?? {}, filters?.TopEstimators ?? {}]
          }
          console.log('Got Top Client Stats', this.cardData)
        }
      } else {
        this.cardData = {
          TopShops: [],
          TopMakes: [],
          TopEstimators: [],
          TopInsurance: [],
          TopServices: [],
          TopEmployees: []
        }
      }
    },
    async getCardData(id) {
      // get top statistics from Dashboard (Connect Rollup at LaunchPad)
      const store = authStore()
      this.cardData = null
      this.routeBack = null
      console.log('Getting Top Client Stats (cardData)', this.isFetching)
      if (this.isFetching === false) {
        this.isFetching = true
        let response = await api.get(
          `dashboard/topClientStats?firm=${store.profile.firm}&startDate=${this.startDate}&endDate=${this.endDate}&number=10&direction=top&source=ADAS&lookup=${this.selectedInsurerClass}`
        )
        if (response) {
          await this.processCardData(response)
        }
        this.isFetching = false
      }
    },
    async processTableData(response) {
      if (response) {
        if (response !== '') {
          this.shopCardDataOriginal = response
          await this.shopCardDataOriginal.map((result) => {
            // result.name = result.name.slice(0, 25) + (result.name.length > 25 ? '...' : '')
            if (this.averageAmount) {
              if (result.servicesRequired) {
                let amt = parseFloat(this.averageAmount) * parseFloat(result.servicesRequired)
                if (amt) {
                  result.amount = amt.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }
              }
            }
          })
          console.log('Got Client Location Services', this.shopCardDataOriginal)
          this.tableDetails = {
            tableName: 'calibrationShopList',
            headerProps: {
              pages: 0,
              pageSizes: [
                { name: '10', value: 10 },
                { name: '25', value: 25 },
                { name: '50', value: 50 },
                { name: '100', value: 100 }
              ],
              numItems: 0,
              title: null,
              subtitle: null,
              isTitle: false,
              isPaginated: false,
              isChecked: false,
              isAdd: false,
              isDelete: false,
              toggleButtons: [
                {
                  name: 'Show List',
                  value: 1,
                  checked: false
                },
                {
                  name: 'Show Cards',
                  value: 2,
                  checked: true
                }
              ],
              buttons: null
            },
            listParams: {
              page: 0,
              pageSize: 10,
              filterBy: null,
              searchTerm: null
            },
            datatableProps: {
              showSearch: true,
              showButtons: true,
              showDisplayRows: true,
              showDisplayCurrentCount: true,
              showPagenation: true,
              overflowTable: 'overflow-x'
            },
            tableHeader: [
              { field: 'name', label: '', sortable: false, class: 'custom-column-60-center' },
              { field: 'name', label: 'Shop Name & Location', sortable: true },
              {
                field: 'inspections',
                label: 'ADAS Inspections',
                sortable: false,
                class: 'text-center'
              },
              {
                field: 'servicesRequired',
                label: 'Service Ops',
                sortable: false,
                class: 'text-center'
              }
            ],
            columns: [null, null, null],
            searchPlaceholder: 'Search',
            buttonsData: this.tableDefaultButtons,
            tableData: JSON.parse(JSON.stringify(this.shopCardDataOriginal))
          }
          this.shopCardData = JSON.parse(JSON.stringify(this.shopCardDataOriginal))
        }
      } else {
        this.shopCardData = 'noData'
        this.tableDetails = {
          tableName: 'calibrationShopList',
          tableData: 'noData'
        }
      }
    },
    async getTableData(id) {
      // get locations/services from Dashboard (Connect Rollup at LaunchPad)
      if (this.isRefresh || this.tableDetails === null) {
        const store = authStore()
        this.shopCardDataOriginal = null
        this.shopCardData = null
        this.tableDetails = null
        if (!this.isFetching) {
          if (id === undefined || id === null) {
            id = store.profile.firm
          }
          this.isFetching = true
          let response = await api.get(
            `dashboard/clientLocationServices?firm=${id}&startDate=${this.startDate}&endDate=${this.endDate}&source=ADAS&lookup=${this.selectedInsurerClass}`
          )
          if (response) {
            await this.processTableData(response)
          }
          this.isFetching = false
        }
      }
    },
    processTotals(response) {
      if (response !== '') {
        this.totals = response
        this.totals.forEach((total) => {
          this.totalInspections += total.total
        })
      }
      console.log('Got Client Totals', {
        totals: this.totals,
        totalInspections: this.totalInspections
      })
    },
    async getTotals(id) {
      // get totals from Dashboard (Connect Rollup at LaunchPad)
      if (this.isRefresh || this.totalInspections === 0) {
        if (!this.isFetching) {
          const store = authStore()
          this.totalInspections = 0
          this.totals = []
          this.isFetching = true
          if (id === undefined || id === null) {
            id = store.profile.firm
          }
          let response = await api.get(
            `dashboard/clientTotals?firm=${id}&startDate=${this.startDate}&endDate=${this.endDate}&source=ADAS&type=Total&lookup=${this.selectedInsurerClass}`
          )
          if (response) {
            this.processTotals(response)
          }
          this.isFetching = false
        }
      }
      return this.totals
    },
    async getGraphData(id) {
      if (this.isRefresh || this.chartData === null) {
        const store = authStore()
        this.chartData = null
        let response = await api.get(
          `dashboard/clientTotals?firm=${store.profile.firm}&startDate=${this.startDate}&endDate=${this.endDate}&source=ADAS&lookup=${this.selectedInsurerClass}`
        )
        if (response) {
          if (response !== '') {
            let chartData = {
              totalInspectionData: {
                label: '',
                totalCount: 0,
                averagePercent: 0,
                resultData: [],
                borderColor: 'rgb(54, 150, 255)',
                backgroundColorFirst: 'rgba(54, 150, 255, 0.4)',
                backgroundColorSecond: 'rgba(54, 150, 255, 0.1)',
                categories: [],
                data: [],
                splineData: []
              },
              totalRoData: {
                label: '',
                totalCount: 0,
                averagePercent: 0,
                resultData: [],
                borderColor: 'rgb(255, 159, 54)',
                backgroundColorFirst: 'rgba(255, 159, 54, 0.4)',
                backgroundColorSecond: 'rgba(255, 159, 54, 0.1)',
                categories: [],
                data: [],
                splineData: []
              }
            }
            await response.map((result) => {
              if (result.metric === 'TotalInspections') {
                chartData.totalInspectionData.totalCount += result.total
                chartData.totalInspectionData.resultData.push({
                  date: result.evalDate,
                  total: result.total,
                  name: result.name
                })
              } else if (result.metric === 'TotalRepairs') {
                chartData.totalRoData.totalCount += result.total
                chartData.totalRoData.resultData.push({
                  date: result.evalDate,
                  total: result.total,
                  name: result.name
                })
              }
            })
            chartData.totalInspectionData.averagePercent = (
              (chartData.totalInspectionData.totalCount / (chartData.totalInspectionData.resultData.length * 100)) *
              100
            ).toFixed(2)
            chartData.totalInspectionData.totalCount = chartData.totalInspectionData.totalCount.toLocaleString()
            chartData.totalInspectionData.resultData = await this.sortArrayByDate(chartData.totalInspectionData.resultData)
            chartData.totalInspectionData.data = await chartData.totalInspectionData.resultData.map((item) => item.total)
            chartData.totalInspectionData.categories = await chartData.totalInspectionData.resultData.map((item) => item.date)
            chartData.totalInspectionData.splineData.push({
              name: '# Inspections',
              data: chartData.totalInspectionData.data
            })
            chartData.totalRoData.averagePercent = (
              (chartData.totalRoData.totalCount / (chartData.totalRoData.resultData.length * 100)) *
              100
            ).toFixed(2)
            chartData.totalRoData.totalCount = chartData.totalRoData.totalCount.toLocaleString()
            chartData.totalRoData.resultData = await this.sortArrayByDate(chartData.totalRoData.resultData)
            chartData.totalRoData.data = await chartData.totalInspectionData.resultData.map((item) => item.total)
            chartData.totalRoData.categories = await chartData.totalInspectionData.resultData.map((item) => item.date)
            chartData.totalRoData.splineData.push({
              name: '# ROs',
              data: chartData.totalRoData.data
            })
            this.chartData = chartData
            console.log('Got Client Totals', this.chartData)
          }
        } else {
          this.chartData = {
            totalInspectionData: {
              label: null
            },
            totalRoData: {
              label: null
            }
          }
        }
      }
    },
    async getServicesDetail(data) {
      if (this.selectedFirm === null) {
        this.selectedFirm = 0
      }
      let isRefresh = false
      if (this.breakdownData === null || this.breakdownTotals.length === 0) {
        isRefresh = true
      }
      if (isRefresh) {
        const store = authStore()
        this.breakdownData = null
        this.breakdownTotals = []
        this.isFetching = true
        let response = await api.get(
          `dashboard/clientLocationServicesDetail?firmId=${store.profile.firm}&firm=${data.firm}&startDate=${data.startDate}&endDate=${data.endDate}&source=${data.source}&lookup=${this.selectedInsurerClass}`
        )
        if (response) {
          if (response !== '') {
            this.breakdownData = response
            try {
              this.breakdownData.forEach((element) => {
                if (element.calibration !== null) {
                  let found = this.breakdownTotals.find((x) => x.name === element.calibration)
                  if (found) {
                    found.count++
                  } else {
                    this.breakdownTotals.push({
                      name: element.calibration,
                      count: 1,
                      completed: 0
                    })
                  }
                }
              })
              console.log('Got Client Location Services Detail', this.breakdownTotals)
            } catch (error) {
              console.log('Error: Client Location Services Detail', this.breakdownTotals)
            }
          }
        } else {
          this.breakdownTotals = 'noData'
          console.log('Error: Client Location Services Detail', this.breakdownTotals)
        }
        this.isFetching = false
      }
    },
    async getServicesBreakdown(data) {
      // get breakdown of services from Dashboard (Connect Rollup at LaunchPad)
      if (this.selectedFirm === null) {
        this.selectedFirm = 0
      }
      let isRefresh = false
      if (this.breakdownData === null || this.breakdownTotals.length === 0) {
        isRefresh = true
      }
      if (isRefresh) {
        const store = authStore()
        this.breakdownData = null
        this.breakdownTotals = []
        this.isFetching = true
        let response = await api.get(
          `dashboard/clientLocationServicesBreakdown?firmId=${store.profile.firm}&firm=${data.firm}&startDate=${data.startDate}&endDate=${data.endDate}&source=${data.source}&lookup=${this.selectedInsurerClass}`
        )
        if (response) {
          if (response !== '') {
            this.breakdownData = response
            try {
              this.breakdownData.forEach((element) => {
                let found = this.breakdownTotals.find((x) => x.name === element.service)
                if (found) {
                  found.count += parseInt(element.servicesRequired)
                  found.completed += parseInt(element.servicesCompleted)
                } else {
                  this.breakdownTotals.push({
                    name: element.service,
                    count: element.servicesRequired,
                    completed: element.servicesCompleted
                  })
                }
              })
              console.log('Got Client Location Services Breakdown', this.breakdownTotals)
            } catch (error) {
              console.log('Error: Client Location Services Breakdown', this.breakdownTotals)
            }
          }
        } else {
          this.breakdownTotals = 'noData'
          console.log('Error: Client Location Services Breakdown', this.breakdownTotals)
        }
        this.isFetching = false
      }
    },
    async getLocationInspections(options) {
      // get totals from Dashboard (Connect Rollup at LaunchPad)
      if (this.selectedFirm === null) {
        this.selectedFirm = 0
      }
      let isRefresh = false
      if (this.inspectionData === null) {
        isRefresh = true
      }
      if (isRefresh) {
        const store = authStore()
        this.inspectionData = null
        this.isFetching = true
        let pageOffset = 0
        if (options.page && options.pageSize) {
          pageOffset = parseInt(options.page) * parseInt(options.pageSize)
        }
        let id = store.profile.firm
        let response = await api.get(
          `dashboard/clientLocationInspections?firmId=${id}&firm=${options.firm}&searchTerm=${options.search}&orderBy=${options.orderBy}&sortBy=${options.sortBy}&offset=${pageOffset}&pageSize=${options.pageSize}&startDate=${options.startDate}&endDate=${options.endDate}&source=${options.source}&lookup=${this.selectedInsurerClass}`
        )
        if (response) {
          if (response !== '') {
            if (response.items === null) {
              this.inspectionData = 'noData'
            } else {
              this.inspectionData = response
              if (this.inspectionData) {
                if (this.inspectionData.items) {
                  this.inspectionData.items.forEach((element) => {
                    element.numberServices = element.services ? element.services.length : 0
                  })
                }
              }
            }
            console.log('Got ADAS Inspections', {
              response: response,
              inspectionData: this.inspectionData
            })
          }
        }
        this.isFetching = false
      }
    },
    async searchByVin(vin) {
      this.vinSearchResults = null
      if (vin) {
        let response = await api.get(`dashboard/searchByVin?firm=${this.selectedCorp}&vin=${vin}&lookup=${this.selectedInsurerClass}`)
        if (response) {
          if (response !== '') {
            console.log('Got VIN Search Results', response)
            if (Array.isArray(response)) {
              this.vinSearchResults = response
              this.vinSearchResults.forEach(element => {
                if (element.inspections && element.inspections.length > 0) {
                  element.insuranceName = element.inspections[0].insuranceName
                }
              })
            }
          }
        }
      }
    },
    async getProviderDashboard(options) {
      if (options) {
        if (!this.isFetching) {
          const store = locationStore()
          this.providerDashboard = []
          this.isFetching = true
          let number = 0
          let color = ''
          let response = await api.get(
            `dashboard/getProviderDashboard?firm=${options.firm}&startDate=${options.startDate}&endDate=${options.endDate}&status=${options.status}`
          )
          if (response) {
            if (response !== '') {
              color = '#B3D7FF'
              this.providerDashboard.push({
                name: '# Postal Codes',
                number: response.numPostalCodes,
                notes: 'Number of Postal Codes in Service Area',
                color: color,
                panel: 1
              })
              this.providerDashboard.push({
                name: '# Referrals',
                number: response.numRequests,
                notes: 'Number of Referral Requests Received',
                color: color,
                panel: 1
              })
              this.providerDashboard.push({
                name: '# Calibrations',
                number: response.numCalibrations,
                notes: 'Number of Calibrations Required',
                color: color,
                panel: 1
              })
              this.providerDashboard.push({
                name: 'Total Revenue $',
                number: response.totalRevenue.toFixed(2),
                notes: 'Total Revenue $ from Referrals',
                color: color,
                panel: 1
              })
              this.providerDashboard.push({
                name: 'Revenue Share $',
                number: response.revenueShare.toFixed(2),
                notes: 'Revenue Share $ from Lead Requests',
                color: color,
                panel: 1
              })
              // this.providerDashboard.push({
              //   name: 'Negotiated $',
              //   number: response.totalIS,
              //   notes: null,
              //   color: color
              // })
              // this.providerDashboard.push({
              //   name: 'Internal $',
              //   number: response.totalISNOT,
              //   notes: null,
              //   color: color
              // })
              // if (store.preferences) {
              //   if (store.preferences.length > 0) {
              //     color = '#FFC6C6'
              //     let total = 0
              //     store.preferences.forEach((element) => {
              //       switch (element.name) {
              //         case 'PostalCodeFee':
              //           let fees = JSON.parse(element.value)
              //           number = 0
              //           fees.forEach((fee) => {
              //             if (response.numPostalCodes >= fee.RangeStart && response.numPostalCodes <= fee.RangeEnd) {
              //               number = parseFloat(response.numPostalCodes) * parseFloat(fee.Value)
              //             }
              //           })
              //           this.providerDashboard.push({
              //             name: element.visualName,
              //             number: number.toFixed(2),
              //             notes: element.description,
              //             color: color,
              //             panel: 2
              //           })
              //           total += number
              //           break
              //       }
              //     })
              //     // referral fees are now summed server-side in revenueShare
              //     total += parseFloat(response.revenueShare)
              //     this.providerDashboard.push({
              //       name: 'Total Fees $',
              //       number: total.toFixed(2),
              //       notes: '<p><b>Total $</b> of Postal Code and Referral Fees</p>',
              //       color: color,
              //       panel: 2
              //     })
              //   }
              // }
            }
          }
          console.log('Got Provider Dashboard', this.providerDashboard)
          this.isFetching = false
        }
      }
      return this.providerDashboard
    },
    async sortArray(data, sortOn, dir) {
      let _data = Array.from(new Set(data)).sort(function (a, b) {
        if (a[0] === b[0]) {
          var x = a[sortOn]
          var y = b[sortOn]
          if (dir) {
            if (dir.toUpperCase() === 'ASC') {
              return x < y ? -1 : x > y ? 1 : 0
            }
            if (dir.toUpperCase() === 'DESC') {
              return x > y ? -1 : x < y ? 1 : 0
            }
          } else {
            return x < y ? -1 : x > y ? 1 : 0
          }
        }
        return a[0] - b[0]
      })
      this.inspectionData.items = _data
      return _data
    }
  }
})
